const clearTableData = function ({ commit }) {
  commit("setLocationTwilio", {})
  commit("setPhoneNumbers", [])
  commit("setNumberPoolIDs", [])
  commit("setNumberPools", [])
  commit("setCallerIDs", [])
  commit("setTable", {
    searchText: "",
    currentPage: 1,
    totalPages: 0,
    limit: 10,
  })
  commit("setTotalPhoneNumbers", 0)
  commit("setTotalNumberPools", 0)
  commit("setTotalVerifiedCallerIDs", 0)
  commit("setTableRecordsCount", 0)
  commit("clearPhoneNumbersLookupTable")
  commit("clearMapPhoneNumberSID")
}

export default clearTableData
